import {
  Container,
  Box,
  Alert,
  Snackbar,
  Backdrop,
  CircularProgress,
  Typography,
  Paper,
  Icon,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Chip,
  Menu,
  MenuItem,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  DialogTitle,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CheckoutFooter from "../components/footer";
import AppConfig from "../../appConfig";
import axios from "../../axios";
import usePageTitle from "../pageTitle";
import FormSectionBuilder from "../components/data_forms/form_section_builder";
import { useGeolocated } from "react-geolocated";

function DataCaptureOfflinePage() {
  const [pageTitle, setPageTitle] = useState("Data Capture");
  usePageTitle(pageTitle);

  const { ref } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [banner, setBanner] = useState(null);
  const [campaign, setCampaign] = useState(null);
  const [dataForm, setDataForm] = useState(null);
  const [dataFormSections, setDataFormSections] = useState([]);

  const [statusMsg, setStatusMsg] = useState("");
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);
  const [openErrorDialog, setOpenErrorDialog] = useState(false);

  const [saveRecords, setSaveRecords] = useState([]);
  const [openSyncDialog, setOpenSyncDialog] = useState(false);

  const [isOnline, setIsOnline] = useState(navigator.onLine);

  const [showCacheUpdateDialog, setShowCacheUpdateDialog] = useState(false);

  useEffect(() => {
    if (ref === null) {
      navigate("/error");
      alert("NONE");
      return;
    }

    setIsOnline(navigator.onLine);

    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`data_captures/${ref}/fetch.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            // console.log(result.data.data);
            setBanner(result.data.data.banner);
            setCampaign(result.data.data.campaign);
            setDataForm(result.data.data.campaign.data_form);
            setPageTitle(
              `${result.data.data.campaign.account.name} | ${result.data.data.campaign.title}`
            );

            // Handle App Update
            const currentVersion = localStorage.getItem(
              AppConfig.app_version_store
            );
            const newVersion = result.data.version;
            if (currentVersion !== newVersion) {
              localStorage.setItem(AppConfig.app_version_store, newVersion);
              if (
                window.confirm("New version available. Reloading...") === true
              ) {
                window.location.reload(true);
              } else {
                window.location.reload(true);
              }
              return;
            }
          } else {
            // setSeverity("error");
            // setErrMsg(result.data.data.message);
            // setOpen(true);
            navigate("/error");
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();

    // Check cache was initialised successfully
    caches.open(ref).then(async function (cache) {
      const keys = await cache.keys();
      if (keys.length <= 0) {
        setShowCacheUpdateDialog(true);
        return;
      }
    });
  }, []);

  // useEffect(() => {
  //   const sections = [];
  //   if (dataForm === null) {
  //     return;
  //   }

  //   dataForm.form.form.sections.every(async (param) => {
  //     // console.log(param);
  //     const sect = <FormSectionBuilder section={param} />;
  //     sections.push(sect);
  //     return false;
  //   });
  //   // console.log(sections);
  //   setDataFormSections(sections);
  // }, [dataForm]);

  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
    useGeolocated({
      positionOptions: {
        enableHighAccuracy: true,
      },
      userDecisionTimeout: 5000,
    });

  function getGPSCoords() {
    if (!isGeolocationAvailable) {
      return false;
    }

    if (!isGeolocationEnabled) {
      return false;
    }

    if (coords) {
      return { latitude: coords.latitude, longitude: coords.longitude };
    }

    return false;
  }

  function getFormFieldDisplayName(fieldRef) {
    if (dataForm === null) {
      return "Unknown field";
    }

    let dName = "";
    dataForm.form.form.sections.every((section) => {
      section.fields.every((field) => {
        if (field.reference === fieldRef) {
          dName = `${field.display_name} (${section.title})`;
        }
        return true;
      });
      return true;
    });

    return dName ? dName : false;
  }

  function preprocessDataForm() {
    /* eslint-disable no-restricted-syntax */

    const dForm = document.querySelector(`#dataForm`);
    const formData = new FormData(dForm);
    const values = Object.fromEntries(formData.entries());

    let exludedName = "";
    let excluded = false;

    dataForm.form.form.sections.every((section) => {
      const ex = section.fields.every((field) => {
        if (!field.is_optional) {
          if (
            !formData.has(field.reference) ||
            values[field.reference].length <= 0
          ) {
            excluded = true;
            exludedName = `${field.display_name} (${section.title})`;
            return false;
          }
        }
        return true;
      });

      return ex;
    });

    if (excluded === true) {
      setSeverity("error");
      setErrMsg(`${exludedName} is not provided.`);
      setOpen(true);
      return false;
    }

    return values;
  }

  async function capture() {
    const gpsCoords = getGPSCoords();
    console.log(gpsCoords);
    if (!gpsCoords) {
      setSeverity("error");
      setErrMsg("Please enable and allow browser's location and GPS access.");
      setOpen(true);
      return;
    }

    let dataFormValues = {};
    if (dataForm !== null) {
      const values = preprocessDataForm();
      if (values === false) {
        return;
      }
      dataFormValues = values;
    } else {
      setSeverity("error");
      setErrMsg("Data form not initialized. Select a campaign to proceed.");
      setOpen(true);
      return;
    }
    // console.log(dataFormValues);

    if (window.confirm("Are you sure you want to proceed?") === false) {
      return;
    }

    setShowLoading(true);
    const json = {
      reference: ref,
      campaign: campaign.reference,
      form: dataForm.reference,
      data: dataFormValues,
      latitude: gpsCoords.latitude,
      longitude: gpsCoords.longitude,
    };

    // console.log(json);
    if (navigator.onLine) {
      sendToServer(json);
    } else {
      saveLocally(json);
    }
  }

  async function sendToServer(data) {
    await axios
      .post("data_captures/capture.json", data)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          setErrMsg(result.data.data.message);
          setStatusMsg(result.data.data.message);
          setOpenSuccessDialog(true);
        } else {
          // setSeverity("error");
          // setErrMsg(result.data.data.message);
          // setOpen(true);

          setStatusMsg(result.data.data.message);
          setOpenErrorDialog(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        // setSeverity("error");
        // setErrMsg(
        //   `Unable to complete request. ${
        //     navigator.onLine ? "" : "Make sure you have an active internet connection"
        //   }`
        // );
        // setOpen(true);

        setStatusMsg("An unexpected error occurred. Please try again later.");
        setOpenErrorDialog(true);
      });
  }

  function saveLocally(data) {
    let submissions = [];
    const saveSubmissions = localStorage.getItem(ref);
    if (saveSubmissions !== null) {
      submissions = JSON.parse(saveSubmissions);
    }

    const timestampInSecondsInteger = Math.floor(Date.now() / 1000);
    data["timestamp"] = timestampInSecondsInteger;
    submissions.push(data);
    localStorage.setItem(ref, JSON.stringify(submissions));

    setShowLoading(false);
    setStatusMsg("Saved offline successfully.");
    setOpenSuccessDialog(true);
  }

  function saveCurrentPage() {
    // const htmlContent = document.documentElement.outerHTML;
    const newDoc = document.implementation.createHTMLDocument("New Document");
    const mlink = newDoc.createElement("a");
    mlink.href = window.location.href;
    newDoc.body.appendChild(mlink);

    const stringHtml = `<html>
          <body>
            <div align="center">
            <span>Offline Forms</span>
            <h3>${campaign.title}</h3>
            <p>
              <a href="${window.location.href}">Open Form</a>
            </p>
            </div>
          </body>
          <script>
            window.onload = function() {
              window.location.replace("${window.location.href}");
            };
          </script>
        </html>
    `;

    const blob = new Blob([stringHtml], { type: "text/html" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `${campaign.title}.html`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);

  async function syncRecords() {
    if (!isOnline) {
      setSeverity("error");
      setErrMsg(
        "You are offline. Make sure you have an active internet connection."
      );
      setOpen(true);
      return;
    }

    let submissions = [];
    const saveSubmissions = localStorage.getItem(ref);
    if (saveSubmissions !== null) {
      submissions = JSON.parse(saveSubmissions);
    }

    if (submissions.length <= 0) {
      setSeverity("error");
      setErrMsg("No offline records found.");
      setOpen(true);
      return;
    }

    // console.log(submissions);
    setShowLoading(true);

    const json = {
      reference: ref,
      data: submissions,
    };

    await axios
      .post("data_captures/offline/sync.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          localStorage.removeItem(ref);

          setErrMsg(result.data.data.message);
          setStatusMsg(result.data.data.message);
          setOpenSuccessDialog(true);
        } else {
          setStatusMsg(result.data.data.message);
          setOpenErrorDialog(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setStatusMsg("An unexpected error occurred. Please try again later.");
        setOpenErrorDialog(true);
      });
  }

  return (
    <>
      <Box mb={5}>
        <Container>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={showLoading}
            onClick={handleClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert
              onClose={handleClose}
              severity={severity}
              sx={{ width: "100%" }}
            >
              {errorMsg}
            </Alert>
          </Snackbar>

          <Dialog open={showCacheUpdateDialog} fullWidth maxWidth="xs">
            <DialogTitle align="center">Activate Offline Mode</DialogTitle>
            <DialogContent>
              <Box mt={3} align="center" mb={3}>
                <Box>
                  <Typography>
                    <Icon color="error" fontSize="large">
                      wifi_off
                    </Icon>
                  </Typography>
                </Box>
                <Box mt={3}>
                  <Typography variant="h6" fontWeight="light" fontSize={14}>
                    Activate this form for offline use.
                  </Typography>
                </Box>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setShowCacheUpdateDialog(false);
                  window.location.reload();
                }}
                color="primary"
                size="small"
                variant="contained"
              >
                Activate
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog open={openSuccessDialog} fullWidth maxWidth="xs">
            <DialogContent>
              <Box mt={3} align="center" mb={3}>
                <Box>
                  <Box mt={1}>
                    <Box sx={{ position: "relative", display: "inline-flex" }}>
                      <CircularProgress
                        variant="determinate"
                        size={120}
                        thickness={2}
                        color="success"
                        value={100}
                      />
                      <Box
                        sx={{
                          top: 0,
                          left: 0,
                          bottom: 0,
                          right: 0,
                          position: "absolute",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Icon color="success" fontSize="large">
                          check
                        </Icon>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                <Box mt={2}>
                  <Typography variant="h6" fontWeight="light">
                    {statusMsg}
                  </Typography>
                </Box>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setOpenSuccessDialog(false);
                  window.location.href = window.location.href;
                }}
                color="primary"
                iconOnly
                circular
                variant="outlined"
              >
                <Icon>close</Icon>
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog open={openErrorDialog} fullWidth maxWidth="xs">
            <DialogContent>
              <Box mt={3} align="center" mb={3}>
                <Box>
                  <Box mt={1}>
                    <Box sx={{ position: "relative", display: "inline-flex" }}>
                      <CircularProgress
                        variant="determinate"
                        size={120}
                        thickness={2}
                        color="error"
                        value={100}
                      />
                      <Box
                        sx={{
                          top: 0,
                          left: 0,
                          bottom: 0,
                          right: 0,
                          position: "absolute",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Icon color="error" fontSize="large">
                          close
                        </Icon>
                      </Box>
                    </Box>
                  </Box>
                </Box>
                <Box mt={2}>
                  <Typography variant="h6" fontWeight="light">
                    {statusMsg}
                  </Typography>
                </Box>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setOpenErrorDialog(false);
                }}
                color="primary"
                iconOnly
                circular
                variant="outlined"
              >
                <Icon>close</Icon>
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog open={openSyncDialog} fullWidth maxWidth="xs">
            <DialogTitle>
              <Box display="flex" justifyContent="space-between">
                <Box>Submit Saved Records</Box>
                <Box
                  variant="button"
                  color="grey"
                  size="small"
                  onClick={() => {
                    setOpenSyncDialog(false);
                  }}
                  align="right"
                >
                  <Icon>cancel</Icon>
                </Box>
              </Box>
            </DialogTitle>
            <DialogContent>
              <Box mt={3} align="center" mb={3}>
                <Box>
                  <Box>
                    <Icon color="info" fontSize="large">
                      checklist_rtl
                    </Icon>
                  </Box>
                  <Box mt={1}>
                    <Typography variant="h6" fontWeight="medium" fontSize={36}>
                      {saveRecords.length}
                    </Typography>
                  </Box>
                  <Box mt={1}>
                    <Typography variant="h6" fontWeight="light" fontSize={14}>
                      Saved Records
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  if (
                    window.confirm(
                      "Delete all saved records? This action is permanent."
                    ) === true
                  ) {
                    localStorage.removeItem(ref);
                    setSaveRecords([]);
                  }
                  return;
                }}
                color="error"
                variant="outlined"
                startIcon={<Icon>close</Icon>}
              >
                Clear
              </Button>
              <Button
                onClick={() => {
                  setOpenSyncDialog(false);
                  syncRecords();
                }}
                color="success"
                variant="outlined"
                startIcon={<Icon>publish</Icon>}
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>

          {campaign !== null && (
            <Box sx={{ margin: "5px auto", maxWidth: "600px" }}>
              <Box mt={1.5} display="flex" justifyContent="space-between">
                <Box mt={1.5}>
                  <Chip
                    size="small"
                    color={isOnline ? "success" : "error"}
                    icon={<Icon>{isOnline ? "wifi" : "wifi_off"}</Icon>}
                    label={isOnline ? "Online" : "Offline"}
                  />
                </Box>
                <Box>
                  <IconButton
                    variant="outlined"
                    id="basic-button"
                    aria-controls={openMenu ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={openMenu ? "true" : undefined}
                    onClick={(e) => {
                      setAnchorEl(e.currentTarget);
                    }}
                  >
                    <Icon>menu</Icon>
                  </IconButton>
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={openMenu}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    <MenuItem
                      onClick={() => {
                        saveCurrentPage();
                        setAnchorEl(null);
                      }}
                    >
                      <ListItem>
                        <ListItemIcon>
                          <Icon>download</Icon>
                        </ListItemIcon>
                        <ListItemText>Download Form</ListItemText>
                      </ListItem>
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        const storage = localStorage.getItem(ref);
                        if (storage) {
                          setSaveRecords(JSON.parse(storage));
                        } else {
                          setSaveRecords([]);
                        }

                        setOpenSyncDialog(true);
                        setAnchorEl(null);
                      }}
                    >
                      <ListItem>
                        <ListItemIcon>
                          <Icon>cloud_sync</Icon>
                        </ListItemIcon>
                        <ListItemText>Sync Records</ListItemText>
                      </ListItem>
                    </MenuItem>
                    <MenuItem
                      onClick={async () => {
                        setAnchorEl(null);
                        if (navigator.onLine) {
                          // await caches.delete(ref);
                          const cache = await caches.open(ref);
                          const keys = await cache.keys();
                          keys.map((key) => cache.delete(key));
                          window.location.reload();
                        } else {
                          alert(
                            "You are not online. Check that you have an active internet connection."
                          );
                        }
                      }}
                    >
                      <ListItem>
                        <ListItemIcon>
                          <Icon>sync</Icon>
                        </ListItemIcon>
                        <ListItemText>Reload Form</ListItemText>
                      </ListItem>
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        setAnchorEl(null);
                      }}
                    >
                      <ListItem>
                        <ListItemIcon>
                          <Icon>close</Icon>
                        </ListItemIcon>
                        <ListItemText>Close</ListItemText>
                      </ListItem>
                    </MenuItem>
                  </Menu>
                </Box>
              </Box>
              <Box mt={3}>
                <Paper elevation={0}>
                  <Box p={2} align="center">
                    <Box>
                      <img
                        src={`${AppConfig.api_media_url}${banner}`}
                        alt="img"
                        style={{ maxWidth: "30%", maxHeight: "100%" }}
                      />
                    </Box>
                    <Box mt={3}>
                      <Typography variant="subtitle1" fontWeight={500}>
                        {campaign.account.name}
                      </Typography>
                    </Box>
                    <Box mt={1}>
                      <Typography variant="caption" fontWeight={350}>
                        {campaign.title}
                      </Typography>
                    </Box>
                  </Box>
                </Paper>
              </Box>
              {campaign.description.length > 0 && (
                <Box mt={3}>
                  <Paper elevation={3}>
                    <Box p={2}>
                      <Box>
                        <Typography variant="caption" fontWeight="regular">
                          DESCRIPTION
                        </Typography>
                      </Box>
                      <Box mt={2}>
                        <Typography variant="caption" fontSize={12}>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: campaign.description,
                            }}
                          />
                        </Typography>
                      </Box>
                    </Box>
                  </Paper>
                </Box>
              )}

              {/* {dataForm !== null && (
                <form id="dataForm">
                  {dataFormSections.map((section) => (
                    <Box mt={5} mb={3}>
                      <Paper elevation={3}>
                        <Box px={3} py={3}>
                          {section}
                        </Box>
                      </Paper>
                    </Box>
                  ))}
                </form>
              )} */}

              {dataForm !== null && (
                <form id="dataForm">
                  <Box>
                    {dataForm.form.form.sections.map((formSection) => {
                      let sect = <></>;
                      if (
                        formSection.reference in
                        dataForm.form.form.navigation_logic.listeners
                      ) {
                        const listener =
                          dataForm.form.form.navigation_logic.listeners[
                            formSection.reference
                          ];
                        const wID = `t_watcher_${listener.type}_${formSection.reference}`;
                        sect = (
                          <div id={`${wID}`} style={{ display: "none" }}>
                            <Box mt={5} mb={3}>
                              <Paper elevation={3}>
                                <Box px={3} py={3}>
                                  <FormSectionBuilder
                                    section={formSection}
                                    logic={dataForm.form.form.navigation_logic}
                                  />
                                </Box>
                              </Paper>
                            </Box>
                          </div>
                        );
                        setTimeout(async () => {
                          const parentField = document.getElementById(
                            `dff_${listener.trigger}`
                          );
                          parentField.addEventListener("change", function () {
                            const d = document.getElementById(wID);
                            if (parentField.value !== listener.control) {
                              d.style.display = "none";
                              formSection.fields.every((fld) => {
                                document.getElementById(
                                  `dff_${fld.reference}`
                                ).value = null;
                                return false;
                              });
                            } else {
                              d.style.display = "block";
                            }
                          });
                        }, 1000);
                      } else {
                        sect = (
                          <Box mt={5} mb={3}>
                            <Paper elevation={3}>
                              <Box px={3} py={3}>
                                <FormSectionBuilder
                                  section={formSection}
                                  logic={dataForm.form.form.navigation_logic}
                                />
                              </Box>
                            </Paper>
                          </Box>
                        );
                      }
                      return sect;
                    })}
                  </Box>
                </form>
              )}

              <Box mt={7} align="center">
                <Button
                  size="large"
                  sx={{ width: { xs: "100%", md: "100%", lg: "100%" } }}
                  startIcon={<Icon>{isOnline ? "publish" : "save"}</Icon>}
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    capture();
                  }}
                >
                  {isOnline ? "Submit" : "Save offline"}
                </Button>
              </Box>
            </Box>
          )}
        </Container>
      </Box>
      <CheckoutFooter />
    </>
  );
}

export default DataCaptureOfflinePage;
